import React from "react";
import { DL_FILTER_EVENT, DL_FILTER_ACTION_ON } from "helpers/constants";
import { datalayerWrapper } from "lib/analytics/datalayerHelpers";
import Styles from "./styles.scss";

export const FilterRadioGroupItem = ({ id, displayName, value, checked, onChange }) => (
    <li>
        <label className="filter__radio-group__label" htmlFor={id}>
            <input
                type="radio"
                name={displayName}
                id={id}
                checked={checked}
                className="filter__radio-group__input"
                value={value || "none"}
                onChange={onChange}
                data-testid="radio-item"
            />
            <span>{displayName}</span>
        </label>
    </li>
);

export const FilterRadioGroup = ({
    options,
    selected,
    classes,
    total,
    dataTestId = "filter-radio-group",
    filterId,
    handleChange,
    datalayerKey,
    dontSendClickToDataLayer
}) => {
    const onChangeHandler = ({ currentTarget: { value } }) => {
        const val = value === "none" ? [] : [value];

        if (val.length && window?.dataLayer && !dontSendClickToDataLayer) {
            window.dataLayer = window.dataLayer || [];

            datalayerWrapper({
                event: DL_FILTER_EVENT,
                filter_action: DL_FILTER_ACTION_ON,
                filter_name: datalayerKey,
                filter_value: val
            });
        }
        handleChange(filterId, val);
    };

    return options ? (
        <>
            <style jsx>{Styles}</style>
            <ul className={`filter__radio-group ${classes}`} data-testid={dataTestId}>
                {options.map(({ id, displayName }) => (
                    <FilterRadioGroupItem
                        id={id}
                        key={`${filterId}_${id}`}
                        displayName={displayName}
                        checked={selected === id}
                        value={id}
                        onChange={onChangeHandler}
                        total={total}
                    />
                ))}
            </ul>
        </>
    ) : null;
};
